module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/AlertCircle.d83877e3.svg";